import {Routes} from "@angular/router";
import {AccountViewUsersComponent} from "./account-view-users/account-view-users.component";
import {AccountViewPurchasesComponent} from "./account-view-purchases/account-view-purchases.component";
import {AccountViewProjectsComponent} from "./account-view-projects/account-view-projects.component";
import {AccountViewInfoComponent} from "./account-view-info/account-view-info.component";
import {routerHandler} from "../../../resources/utils/router";

export const AccountViewRoutesData = {
  'redirect': routerHandler.redirect('account'),
  'users': routerHandler.users('account', {component: AccountViewUsersComponent}),
  'info': routerHandler.info('account', {component: AccountViewInfoComponent}),
  // 'projects': routerHandler.projects('account', {component: AccountViewProjectsComponent}),
  // 'purchases': routerHandler.purchases('account', {component: AccountViewPurchasesComponent}),
};

export const AccountViewRoutes: Routes = Object.values(AccountViewRoutesData);
